"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = uplaodCos;
exports.getTempUrl = getTempUrl;
exports.initCos = initCos;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _util = require("./util");
var _fetch = require("../utils/fetch");
var Cdn = 'media.zhuanstatic.com';
var Bucket = 'cs-1255305554';
var Region = 'ap-beijing';
var Path = 'csvideo/';
var cos = null;
function loadSdk() {
  return _loadSdk.apply(this, arguments);
}
function _loadSdk() {
  _loadSdk = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return new Promise(function (resolve, reject) {
            (0, _util.loadJs)('https://s1.zhuanstatic.com/common/trade/cos-js-sdk-v5.min.js', resolve);
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _loadSdk.apply(this, arguments);
}
function initCos(_x, _x2) {
  return _initCos.apply(this, arguments);
}
function _initCos() {
  _initCos = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(options, initCb) {
    var tencentCdnOpt;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!cos) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return");
        case 2:
          if (window.COS) {
            _context2.next = 5;
            break;
          }
          _context2.next = 5;
          return loadSdk();
        case 5:
          tencentCdnOpt = !options || typeof options === 'boolean' ? {} : options;
          if (tencentCdnOpt.Bucket || tencentCdnOpt.Cdn) {
            if (tencentCdnOpt.Bucket && tencentCdnOpt.Cdn) {
              Bucket = tencentCdnOpt.Bucket;
              Cdn = tencentCdnOpt.Cdn;
            } else {
              console.error('Bucket 和 Cdn 必须同时配置，一一对应');
            }
          }
          cos = new window.COS(Object.assign({}, tencentCdnOpt, {
            getAuthorization: function getAuthorization(options, callback) {
              (0, _fetch.fetch)({
                url: 'https://app.zhuanzhuan.com/fecommon/qcloud/CosSts'
              }).then(function (res) {
                var credentials = res.respData.credentials;
                callback({
                  TmpSecretId: credentials.tmpSecretId,
                  TmpSecretKey: credentials.tmpSecretKey,
                  XCosSecurityToken: credentials.sessionToken,
                  ExpiredTime: res.respData.expiredTime
                });
              }).catch(function (err) {
                initCb(err);
              });
            }
          }));
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _initCos.apply(this, arguments);
}
function getTempUrl(_x3, _x4) {
  return _getTempUrl.apply(this, arguments);
}
function _getTempUrl() {
  _getTempUrl = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(options, callback) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (callback === void 0) {
            callback = function callback() {};
          }
          _context3.next = 3;
          return initCos(null, callback);
        case 3:
          cos.getObjectUrl({
            Bucket: Bucket,
            Region: Region,
            Key: options.Key,
            Expires: options.Expires || 60 * 60 * 24 // 默认过期时间一天，供用户在当前页面预览应该足够了
          }, function (err, data) {
            if (data && data.Url) {
              data.Url = data.Url.replace(Bucket + ".cos." + Region + ".myqcloud.com", "" + Cdn);
            }
            callback(err, data);
          });
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getTempUrl.apply(this, arguments);
}
function uplaodCos(_x5, _x6, _x7) {
  return _uplaodCos.apply(this, arguments);
}
function _uplaodCos() {
  _uplaodCos = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(file, options, callback) {
    var setStatus, Key;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          setStatus = function _setStatus(status) {
            file.progress = 1;
            file.status = status;
            callback && callback(file);
          };
          if (callback === void 0) {
            callback = function callback() {};
          }
          file.progress = 0;
          file.status = _util.STATUS_UPLOADING;
          Key = Path + (0, _util.generateKey)(file);
          _context4.next = 7;
          return initCos(options.tencentCdnOpt, function () {
            return setStatus(_util.STATUS_ERROR);
          });
        case 7:
          cos.sliceUploadFile({
            SliceSize: 1024 * 1024,
            Bucket: Bucket,
            Region: Region,
            Key: Key,
            ACL: options.tencentCdnAcl || 'default',
            Body: file.file,
            onProgress: function onProgress(data) {
              // progress在触发上传成功事件时才置为1，确保loading状态不消失
              if (data.percent < 1) {
                file.progress = data.percent;
              }
            }
          }, function (err, data) {
            if (err) {
              setStatus(_util.STATUS_ERROR);
              return;
            }
            getTempUrl({
              Key: Key
            }, function (err, data) {
              if (err) {
                setStatus(_util.STATUS_ERROR);
                return;
              }
              file.response = options.videoCover;
              file.source = 'tecentCdn';
              file.url = Key;
              file.urlName = Key;
              file.publicUrl = "https://" + Cdn + "/" + Key;
              file.urlPreview = data.Url;
              setStatus(_util.STATUS_SUCCESS);
            });
          });
        case 8:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _uplaodCos.apply(this, arguments);
}